export const enUs = {
    components: {
        MuiBreadcrumbs: {
            defaultProps: {
                expandText: 'Show path',
            },
        },
        MuiTablePagination: {
            defaultProps: {
                getItemAriaLabel: (type: string) => {
                    if (type === 'first') {
                        return 'Go to first page';
                    }
                    if (type === 'last') {
                        return 'Go to last page';
                    }
                    if (type === 'next') {
                        return 'Go to next page';
                    }

                    // if (type === 'previous') {
                    return 'Go to previous page';
                },
                labelRowsPerPage: 'Rows per page:',
                labelDisplayedRows: ({
                    from,
                    to,
                    count,
                }: {
                    from: number;
                    to: number;
                    count: number;
                    // eslint-disable-next-line no-negated-condition
                }) => `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
            },
        },
        MuiRating: {
            defaultProps: {
                // eslint-disable-next-line no-negated-condition
                getLabelText: (value: number) => `${value} Star${value !== 1 ? 's' : ''}`,
                emptyLabelText: 'Empty',
            },
        },
        MuiAutocomplete: {
            defaultProps: {
                clearText: 'Clear',
                closeText: 'Close',
                loadingText: 'Loading…',
                noOptionsText: 'No options',
                openText: 'Open',
            },
        },
        MuiAlert: {
            defaultProps: {
                closeText: 'Close',
            },
        },
        MuiPagination: {
            defaultProps: {
                'aria-label': 'Pagination navigation',
                getItemAriaLabel: (type: string, page: number, selected: boolean) => {
                    if (type === 'page') {
                        return `${selected ? '' : 'Go to '}page ${page}`;
                    }
                    if (type === 'first') {
                        return 'Go to first page';
                    }
                    if (type === 'last') {
                        return 'Go to last page';
                    }
                    if (type === 'next') {
                        return 'Go to next page';
                    }

                    // if (type === 'previous') {
                    return 'Go to previous page';
                },
            },
        },
    },
};
